<template>
    <div class="dynamic-modal-wrapper" v-if="showMfaPopup">
        <div class="dynamic-modal-bg"></div>
        <div class="dynamic-modal-outer">
            <div class="dynamic-modal-close" @click="closeModal">
                <font-awesome-icon :icon="['fal', 'times-circle']" />
            </div>
            <div class="content">
                <h3 class="heading">Keeping your information secure</h3>
                <p>We are adding an extra security step when you access your benefit information online through the My
                    Pension area of the website.</p>
                <p>Multi-factor authentication (MFA) is one of the most effective ways to protect an online account from
                    scammers and fraudsters. Therefore, we are implementing MFA every time you log in to the My Pension
                    area of the website. The Registration Guide has been updated to help step you through the new
                    process. You can find this guide on the homepage of the website.</p>
                <h3 class="heading">How will multi-factor authentication work?</h3>
                <p>You will still have to provide your email address and password, as before. On successful verification
                    of these, you will now also be required to provide a mobile phone number. A code will then be sent
                    to your phone, which you will need to enter when logging in.</p>
                <p>If you do not own a mobile phone, you will have the ability to verify your identity via an automated
                    phone call to a landline.</p>
                <p>We hope you agree that this is a valuable – and necessary – development to help keep your information
                    secure.</p>
            </div>

            <div class="d-flex justify-content-between align-items-center px-4 py-2 bg-light">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="mfaModalHideForCheckbox">
                    <label class="form-check-label unselectable">
                        Hide this message for one week
                    </label>
                </div>
                <button type="button" class="button-outline-rounded" @click="closeModal">
                    Close
                </button>
            </div>
        </div>
    </div>


</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'mfa-wording-modal',
    data () {
        return {
            showMfaPopup: false,
            modalVisitCount: 0,
            mfaModalHideForCheckbox: false,
        };
    },
    computed: {
        showMFAWording () {
            return this.$store.state.clientConfig.showMFAWording;
        },
    },
    methods: {
        closeModal () {
            this.showMfaPopup = false;
            if (this.mfaModalHideForCheckbox) {
                const sevenDaysInFuture = dayjs().add(1, 'week').valueOf();
                localStorage.setItem('hibernate-mfa-modal', sevenDaysInFuture);
            }
        },
    },
    watch: {
        showMFAWording: {
            handler (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    const hibernationRule = localStorage.getItem('hibernate-mfa-modal');
                    if (!hibernationRule) {
                        this.showMfaPopup = true;
                        return;
                    }
                    if (hibernationRule < dayjs().valueOf()) {
                        this.showMfaPopup = true;
                    }
                }
            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";

.dynamic-modal-wrapper {
    z-index: 15;
    position: fixed;

    .dynamic-modal-bg {
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        position: fixed;
        background: rgba(0, 0, 0, 0.2);

        /* if backdrop support: very transparent and blurred */
        @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
            filter: blur(4px);
            backdrop-filter: blur(8px) grayscale(0.1);
        }
    }

    .dynamic-modal-outer {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        background: white;

        border-radius: 6px;

        .dynamic-modal-close {
            box-shadow: $boxShadow;
            font-size: 26px;
            line-height: 33px;
            position: absolute;
            right: -10px;
            top: -10px;
            width: 35px;
            height: 35px;
            text-align: center;
            background: white;
            border-radius: 50%;
            cursor: pointer;
        }

        .content {
            width: 700px;
            max-height: 660px;
            overflow: auto;
            padding: 1.5rem;
            .heading{
                font-size: 1.6rem;
                font-weight: 600;
                margin-bottom: 1rem;
            }

            @include responsive("xs") {
                width: 90vw;
                height: 80vh;
            }
        }
    }
}

.unselectable {
    user-select: none;
}

.form-check-label {
    font-size: 1rem !important;

}
</style>
